// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1dpYP","bigColWidth":"Table_bigColWidth__pHEfn","biggerColWidth":"Table_biggerColWidth__2eutY","row":"Table_row__1RnYU","col":"Table_col__2QcnB"};